import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import AddDocumentFormModal from '../modals/AddDocumentFormModal'
import EditDocumentFormModal from '../modals/EditDocumentFormModal'
import ViewDocumentModal from '../modals/ViewDocumentModal'
import PortfolioViewModal from '../modals/PortfolioViewModal'
import DeleteDocumentModal from '../modals/DeleteDocumentModal'
import PrintDocumentModal from '../modals/PrintDocumentModal'
import $ from 'jquery';
import tick_img from '../../images/checked.png'
import { connect } from 'react-redux'
import MoreVert from '../../images/sharp-more_vert-24px.svg'
import { Flag } from 'flagger/react'
import DocumentAuditModal from '../modals/DocumentAuditModal';
import DownloadLinkShareModal from '../modals/DownloadLinkShareModal';
import ViewHistoryModal from '../modals/ViewHistoryModal';

class PopoverItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: false,
      modal: false,
      addmodal: false,
      editmodal: false,
      portfoliomodal: false,
      printModal: false,
      deleteModal: false,
      auditModal: false,
      shareModal: false,
      historyModal: false,
      selectedDocument: {},
      selectedFileName: "",
      editMetaData: {},
      permissions: {},
      historyPopover: false,
      associated: false
    };

    this.toggle = this.toggle.bind(this);
    this.adddocument = this.adddocument.bind(this);
    this.editdocument = this.editdocument.bind(this);
    this.documentSelected = this.documentSelected.bind(this);

    this.toggleModal = this.toggleModal.bind(this)
    this.toggle = this.toggle.bind(this)
    this.toggleAddModal = this.toggleAddModal.bind(this);
    this.toggleEditModal = this.toggleEditModal.bind(this);
    this.togglePortfolioModal = this.togglePortfolioModal.bind(this)
    this.toggleDeleteDocument = this.toggleDeleteDocument.bind(this)
    this.togglePrintModal = this.togglePrintModal.bind(this)
    this.getDocumentTypeConfig = this.getDocumentTypeConfig.bind(this)
  }

  componentDidMount = () => {
    const encDocRef = encodeURIComponent(this.props.filename);
    const encDocType = encodeURIComponent(this.props.filetype || this.props.file.DocumentType);
    //Bug 10509 -- update doc type when component updated to fix issue with incorrect document type
    this.getDocumentTypeConfig(encDocRef, encDocType)
  }

  componentDidUpdate(prevProps) {
    if (this.props.filename !== prevProps.filename) {
      const encDocRef = encodeURIComponent(this.props.filename);
      const encDocType = encodeURIComponent(this.props.filetype);
      this.getDocumentTypeConfig(encDocRef, encDocType)
    }
  }

  getDocumentTypeConfig(docRef, docType) {
    //Bug 10509 -- update doc type when component updated to fix issue with incorrect document type
    fetch(window.location.protocol + '//' + window.location.host + '/api/archive/search?DocumentRef=' + docRef + '&DocumentType=' + docType)
      .then(res => res.json())
      .then(result => {
        //console.log(result);
        //loop the returned values and push them to a local state object
        this.setState({
          editMetaData: result.files[0],
          associated: result.files.length > 1
        });
        //close the popup

      }) //should return an array of document types
      .catch(error => {
        //need to log the error
        console.error(error);
      });

    fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentType?parentType=' + docType)
      .then(res => res.json())
      .then(documentType => {
        if (documentType.message) {
          // this.props.alert.error('An error occured whilst getting document configuration, document type ' + docType + ' was not found');
          return;
        }
        else {
          this.setState({ docType: documentType });
        }
      })
      .catch(ex => {
        console.error(ex)
      });
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  toggleHistoryPopover = () => {
    this.setState({
      historyPopover: !this.state.historyPopover
    });
  }

  toggleDeleteDocument() {
    this.setState({
      deleteModal: !this.state.deleteModal,
      popoverOpen: false
    });
  }

  adddocument() {
    //don't toggle yet - if the toggle goes we lose the input
    //TODO: could move the input somewhere else.

    //add the change event
    $("#fileId").change(this.documentSelected);
    //fire the click event
    $("#fileId").trigger("click");
  }

  editdocument() {
    this.toggle();
    //display the add new document modal.
    if (this.state.docType)
      this.toggleEditModal();
    else {
      const encDocType = encodeURIComponent(this.props.filetype);
      this.props.alert.error('Unable to load edit dialog as ' + encDocType + ' was not found');
    }
  }

  documentSelected() {
    //store the selected file
    this.setState({
      selectedDocument: $("#fileId")[0].files[0],
      selectedFileName: $("#fileId")[0].files[0].name
    });
    //close the popup
    this.toggle();
    //display the add new document modal.
    this.toggleAddModal();
  }

  togglePortfolioModal() {
    this.setState({
      portfoliomodal: !this.state.portfoliomodal,
      popoverOpen: false
    });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal,
      popoverOpen: false
    });
  }

  toggleAuditModal = () => {
    this.setState({
      auditModal: !this.state.auditModal,
      popoverOpen: false
    });
  }

  toggleHistoryModal = () => {
    this.setState({
      historyModal: !this.state.historyModal,
      popoverOpen: false
    });
  }

  toggleShareModal = () => {
    this.setState({
      shareModal: !this.state.shareModal,
      popoverOpen: false
    });
  }

  toggleAddModal() {
    try {
      this.setState({
        addmodal: !this.state.addmodal,
        popoverOpen: false

      });
    }
    catch (error) {
      console.error(error)
    }
  }

  toggleEditModal() {
    //Bug 11873 -- only refresh on close; refreshing on open remounts the rows on Search and the modal state is lost
    const closing = this.state.editmodal;

    this.setState({
      editmodal: !this.state.editmodal,
      popoverOpen: false
    });

    if (closing)
      this.props.refresh();
  }

  togglePrintModal() {
    this.setState({
      printModal: !this.state.printModal,
      popoverOpen: false
    });
  }


  render() {
    //seperate style for hidden input.
    var style = {};
    style.display = 'none';
    const { viewpermissions, doctypepermissions } = this.props.userReducer
    const error = {};
    let popoverItems = []
    let id = ''
    let tick = <div />

    let viewDocumentmodelPopup = {}
    let addDocumentModalPopup = {}
    let editDocumentModalPopup = {}
    let portfolioViewModal = {}
    let deleteDocumentModal = {}
    let printDocumentModal = {}
    let documentAuditModal = {}
    let documentShareModal = {}
    let documentHistoryModal = {}
    let popoverItem = {}

    //fix incorrect data being loaded into modal - only load modal data when opened
    if (this.state.modal)
      viewDocumentmodelPopup = <ViewDocumentModal type={this.props.filetype} name={this.props.filename} file={this.props.file} document={this.props.fileid} modal={this.state.modal} toggle={this.toggleModal} />
    else
      viewDocumentmodelPopup = <div />

    if (this.state.addmodal)
      addDocumentModalPopup = <AddDocumentFormModal refresh={this.props.refresh} parentType={this.props.filetype} parentRef={this.props.filename} fileName={this.state.selectedFileName} fileData={this.state.selectedDocument} addmodal={this.state.addmodal} toggleAddModal={this.toggleAddModal} />
    else
      addDocumentModalPopup = <div />

    if (this.state.editmodal)
      editDocumentModalPopup = <EditDocumentFormModal allowEdit={doctypepermissions[this.state.docType.DocumentType].edit_meta} file={this.props.file} DocumentType={this.props.filetype} DocumentRef={this.props.filename} SecondRef={this.props.file.SecondRef} DocTypeConfig={this.state.docType} Version={this.props.file.Version} DateTimeCreated={this.props.file.DateTimeCreated} UserName={this.props.file.UserName} ImportType={this.props.file.ImportType} editMetaData={this.state.editMetaData} editmodal={this.state.editmodal} toggleEditModal={this.toggleEditModal} />
    else
      editDocumentModalPopup = <div />

    if (this.state.portfoliomodal)
      portfolioViewModal = <PortfolioViewModal refresh={this.props.refresh} parentType={this.props.filetype} parentRef={this.props.filename} document={this.props.fileid} modal={this.state.portfoliomodal} toggle={this.togglePortfolioModal} />
    else
      portfolioViewModal = <div />

    if (this.state.deleteModal)
      deleteDocumentModal = <DeleteDocumentModal modal={this.state.deleteModal} refresh={this.props.refresh} toggle={this.toggleDeleteDocument} document={this.props.filename} file={this.props.fileid} />
    else
      deleteDocumentModal = <div />

    if (this.state.printModal)
      printDocumentModal = <PrintDocumentModal modal={this.state.printModal} refresh={this.props.refresh} toggle={this.togglePrintModal} document={this.props.filename} file={this.props.file} />
    else
      printDocumentModal = <div />

    if (this.state.auditModal)
      documentAuditModal = <DocumentAuditModal modal={this.state.auditModal} refresh={this.props.refresh} toggle={this.toggleAuditModal} document={this.props.filename} file={this.props.file} />
    else
      documentAuditModal = <div />

    if (this.state.shareModal)
      documentShareModal = <DownloadLinkShareModal modal={this.state.shareModal} refresh={this.props.refresh} toggle={this.toggleShareModal} file={this.props.file} />
    else
      documentShareModal = <div />

    if (this.state.historyModal)
      documentHistoryModal = <ViewHistoryModal modal={this.state.historyModal} refresh={this.props.refresh} toggle={this.toggleHistoryModal} file={this.props.file} />
    else
      documentHistoryModal = <div />

    if (doctypepermissions && this.state.docType) {
      if (doctypepermissions[this.state.docType.DocumentType]) {
        if (doctypepermissions[this.state.docType.DocumentType].add)
          popoverItems.push(<a class="s-list-default-btn-default s-with-icon" onClick={this.adddocument} title="Add"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-create"></div> Add</a>)
        if (doctypepermissions[this.state.docType.DocumentType].delete)
          popoverItems.push(<a class="s-list-default-btn-default s-with-icon" onClick={this.toggleDeleteDocument} title="Delete"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete"></div> Delete</a>)
        if (doctypepermissions[this.state.docType.DocumentType].view_meta)
          popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.editdocument} title="View Metadata"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />View Metadata</a>)
        if (doctypepermissions[this.state.docType.DocumentType].view_pdf)
          popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" id="test_id" onClick={this.toggleModal} title="View Document"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />View Document</a>)

        // if(doctypepermissions[this.state.docType.DocumentType].print) -- needs implmenting
        popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.togglePrintModal} title="Print"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />Print</a>)

        // if(doctypepermissions[this.state.docType.DocumentType].audit) -- needs implmenting
        popoverItems.push(<Flag flag="DocumentAudit" entity={{ id: 1 }} case="on">
          <a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.toggleAuditModal} title="Audit"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />Audit</a>
        </Flag>);

        popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.toggleHistoryModal} title="History">
          <div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />History</a>);


        if (doctypepermissions[this.state.docType.DocumentType].share)
          popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.toggleShareModal} title="Share Link"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />Share</a>)
      }
    }

    if (this.props.viewPortfolio) {
      popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.togglePortfolioModal} title="Portfolio"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete" />Portfolio</a>)
      id = 'Popover-' + this.props.id + '-portfolio'
    }
    else
      id = 'Popover-' + this.props.id

    if (this.state.associated)
      tick = <img src={tick_img} alt="Has Associated Documents" title="Has Associated Documents" style={{ width: "11px", position: "absolute" }} />

    return (
      <span>
        <Flag flag="v12" entity={{ id: 1 }} case="off">
          <Button className="s-record-picker s-fonticon-btn s-btn-menus" color="secondary" id={id} onClick={this.toggle}>
            
          </Button>
        </Flag>
        <Flag flag="v12" entity={{ id: 1 }} case="on">
          <Button className="s-record-picker s-fonticon-btn s-btn-menus" disabled={this.props.disabled} color="secondary" id={id} onClick={this.toggle}>
            <img src={MoreVert} />
          </Button>
        </Flag>
        <Popover typeof="" placement="top" hideArrow={true} isOpen={this.state.popoverOpen} target={id} toggle={this.toggle}>
          {popoverItems}
          <input
            id="fileId"
            type="file"
            style={style}
            accept=".csv,.doc,.docx,.dwf,.dwg,.eml,.epub,.exif,.gif,.htm,.html,.jpeg,.jpg,.mdb,.md,.msg,.odt,.pcl,.pcx,.pdf,.png,.ppt,.pptx,.psd,.pst,.rar,.raw,.rtf,.tex,.tif,.tiff,.txt,.webp,.xls,.xlsx,.xml,.zip,.7z">
          </input>
        </Popover>
        {viewDocumentmodelPopup}
        {addDocumentModalPopup}
        {editDocumentModalPopup}
        {portfolioViewModal}
        {deleteDocumentModal}
        {printDocumentModal}
        {documentShareModal}
        {documentAuditModal}
        {documentHistoryModal}
      </span>
    );
  }
}

export default connect(state => state)(PopoverItem);